import React from "react";
import Slider from "react-slick";
import bottomArea from "../../../assets/UMSImage/hero-bottom.png";
import slide1 from "../../../assets/UMSImage/SliderImage01.png";
// import slide2 from "../../../assets/UMSImage/SliderImage02.png"

import "./hero.scss";
import Button from "../../Common/Button/Button";
import ImageShape from "../../Common/ImageShape/ImageShape";
import { SliderDetails } from "../../../constants/Home";

const Hero = () => {
  let slider;
  const settings = {
    dot: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay:true
  };
  return (
    <>
      <section id="hero-silder-wrapper">
        <Slider {...settings} ref={s => (slider = s)}>
          {SliderDetails.map((item) => {
            return (
              <>
                <div className="slide-wrapper">
                  <div className="row slide-content">
                    <div className="col-md-6 content" >
                      <h1 className="heading" style={{maxWidth: `${item?.id===1 ? "29.25rem" : " "}`}}>
                        {item?.title} <span>{item?.define}</span>{" "}
                      </h1>
                      <p style={{maxWidth: `${item?.id===1 ? "29.25rem" : " "}`}}>
                       {item?.description}
                      </p>
                      <div className="slider-button" style={{maxWidth: `${item?.id===1 ? "29.25rem" : " "}`}}>
                        <Button id="arrow-wrapper-left" onClick={() => slider.slickPrev()}>Back</Button>
                        <Button id="arrow-wrapper-right"  onClick={() => slider.slickNext()}>Next</Button>
                      </div>
                    </div>
                    <div className="col-md-6">
                   <img src={item?.img} alt="" />
                    </div>
                  </div>
                </div>
              </>
            );
          })}
        </Slider>
      </section>
    </>
  );
};

export default Hero;
